import $xhr from '@/service/xhr'
import $api from '@/service/api'

export const getList = (path, param) => {
    return new Promise((resolve, reject) => {
        $xhr(path, param).then(res => {
            resolve(res)
        })
    })
}
/**
 * @获取节点列表
 * */
export const articleCategory = async(param) => {
    const li = await getList($api.articleCategory, param)
    li.map((v)=>{
        v.path = '/consultation?type='+v.id+'&name='+v.name
        return v
    })
    return li
}
/**
 * @获取节点列表
 * */
export const casesCategory = async(param) => {
    const list = await getList($api.casesCategory, param)
    list.map((v)=>{
        v.path = '/case?type='+v.id+'&name='+v.name
        return v
    })
    return list
}
export const cateList = [
    {
        footerHidden: true,
        name: '首页',
        path: '/',
        parentname: '/',
        id: 1,
    },
    {
        name: '实景案例',
        path: '/case',
        parentname: 'case',
        id: 2,
        child: casesCategory().then(res => {
            cateList.map(v=>{
                if (v.id == 2 )  v.child = res
            })
        }),
    },
    {
        name: '核心竞争力',
        path: '/compety',
        parentname: 'compety',
        id: 3,
        child: [
            {
                name: '管理模式',
                path: '/compety',
            },
            {
                name: '工艺品质',
                path: '/compety/quality',
            },
            {
                name: '服务流程',
                path: '/compety/serviceprocess',
            },
            {
                name: '售后服务',
                path: '/compety/saleservice',
            }
        ],
    },
    {
        name: '战略合作',
        path: '/strategic',
        parentname: 'strategic',
        id: 4,
        child: [
            {
                name: '合作设计师',
                path: '/strategic',
            },
            {
                name: '合作基材',
                path: '/strategic/soft/1',
            },
            {
                name: '合作主材',
                path: '/strategic/soft/2',
            },
            {
                name: '合作软装',
                path: '/strategic/soft/0',
            }
        ],
    },
    {
        name: '隐上资讯',
        path: '/consultation',
        id: 5,
        parentname: 'consultation',
        child: articleCategory().then(res => {
            cateList.map(v=>{
                if (v.id == 5 )  v.child = res
            })
        }),
    },
    {
        name: '关于隐上',
        path: '/about/introduce',
        parentname: 'about',
        id: 6,
        child: [
            {
                name: '隐上简介',
                path: '/about/introduce',
            },
            {
                name: '隐上创始人',
                path: '/about/founder',
            },
            {
                name: '隐上团队',
                path: '/about/team',
            },
            {
                name: '加入我们',
                path: '/about/join',
            },
            {
                name: '联系我们',
                path: '/about/contact',
            },
        ],
    }
]
